import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MODE_ONSITE } from "../constants/constants";
import { useConfig } from "../context/ConfigContext";

import appConfig from "../appConfig";
import { catalogueApi } from "../services/catalogueApi";
import {
  getFiltredShops,
  setSelectedRestaurant
} from "../store/actions/actions";
import { fetchLocation, updateAppState } from "../store/app/appActions";
import { RootState } from "../store/rootState";

export const useAppInit = () => {
  const dispatch = useDispatch();
  const { config } = useConfig();
  const companyId = config?.companyId || 0;
  const restaurants = useSelector((state: RootState) => state.shop.shops);
  const selectedRestaurant = useSelector(
    (state: RootState) => state.shop.selectedRestaurant
  );
  const selectedMode = useSelector(
    (state: RootState) => state.app.selectedMode
  );
  const currentLocation = useSelector(
    (state: RootState) => state.app.currentLocation
  );

  useEffect(() => {
    // 1. Fetch current currentLocation (handled by saga)
    dispatch(fetchLocation());

    // 2. Set default mode if not set
    if (!selectedMode) {
      dispatch(updateAppState({ selectedMode: MODE_ONSITE }));
    }
  }, [dispatch, selectedMode]);

  useEffect(() => {
    // 3. Fetch filtered shops once mode is set 
    if (selectedMode !== undefined) {
      dispatch(
        getFiltredShops(
          {
            diningMode: selectedMode || MODE_ONSITE,
            categories: [],
            adresse: {
              latitude: currentLocation?.latitude || 0,
              longitude: currentLocation?.longitude || 0,
            },
          },
          appConfig.IS_WHITELABEL_MODE ? String(companyId) : undefined
        )
      );
    }
  }, [dispatch, selectedMode, currentLocation, companyId]);

  useEffect(() => {
    // 4. Set default selected restaurant if none is selected

    const setDefaultRestaurant = () => {
      const restaurantToken = localStorage.getItem("establishementToken");
      if ((!selectedRestaurant || !restaurantToken || Object.keys(selectedRestaurant).length === 0) && restaurants.length > 0) {
        const restaurantToSelect = restaurants.sort((a, b) => a.isOpen === b.isOpen ? 0 : a.isOpen ? -1 : 1)[0];
        dispatch(setSelectedRestaurant(restaurantToSelect));
        if (restaurantToSelect.azureUrl && restaurantToSelect.azureUrl !== "") {
          fetchEstablishementToken(restaurantToSelect.azureUrl);
        }
      }
    };

    setDefaultRestaurant();
  }, [dispatch, selectedRestaurant, restaurants]);
};

export async function fetchEstablishementToken(azureUrl: string): Promise<string> {
  try {
    const tokenRes = await catalogueApi.getEstablishementToken(azureUrl);
    const token: string = tokenRes.data.data.result;
    if (token) {
      localStorage.setItem("establishementToken", token);
      return token;
    }
    return "";
  } catch (error) {
    console.error("Failed to fetch establishment token:", error);
    return "";

  }
}
